import { CSSProperties, FC, ReactNode, useEffect, useRef } from 'react';
import { animated, useSpring } from '@react-spring/web';
import styles from './Drawer.module.scss';
import { useOnClickOutside, usePreventScrolling } from '#hooks';

type Props = {
  children: ReactNode;
  position: 'left' | 'right';
  open?: boolean;
  onClose: () => void;
  classes?: string;
  style?: CSSProperties;
};
const Drawer: FC<Props> = ({
  onClose,
  position,
  open,
  classes,
  style,
  children,
}) => {
  const { setPreventScrolling } = usePreventScrolling();
  const ref = useRef();
  const animation = useSpring({
    translateX: open ? '0%' : position === 'left' ? '-100%' : '100%',
  });

  useOnClickOutside(ref, (event: MouseEvent & { target: HTMLElement }) => {
    if (open) {
      if (event.target.id !== 'menu-button') {
        event.preventDefault();
        event.stopPropagation();
        onClose?.();
      }
    }
  });

  useEffect(() => {
    setPreventScrolling(open);
  }, [open]);

  return (
    <animated.div
      ref={ref}
      className={`${styles.host} ${styles[position]} ${classes}`}
      style={{ ...style, ...animation }}
    >
      {children}
    </animated.div>
  );
};

export default Drawer;
